module.exports = __webpack_public_path__ + "img/BeccaPalette1.85ae5aae.jpg";